import {useContext, useState} from "react";
import {useTranslation} from "react-i18next";
import Button from "../../../../components/Button.jsx";
import {GlobalContext} from "../../../../utils/context/GlobalContextProvider.jsx";
import {useNavigate} from "react-router-dom";
import {useErrorTranslation} from "../../../../api/utilities/translateErrorMessage.js";
import HostNameAndXmlLinkList from "../IntegrationFormInput/HostNameAndXmlLinkList.jsx";
import useAuthorityConfiguration from "../../../../api/utilities/useAuthorityConfiguration.js";
import HostNameAndCsvLinkList from "../IntegrationFormInput/HostNameAndCsvLinkList.jsx";
import {ProjectIntegrationsApi} from "../../../../api/authority/generated/index";
import toast from "react-hot-toast";

export default function HeurekaIntegrationForm({project, projectIntegration}) {

    let {t} = useTranslation();
    let {et} = useErrorTranslation();
    let navigate = useNavigate();

    let {resetCurrentUserProjects} = useContext(GlobalContext);

    let authorityConfiguration = useAuthorityConfiguration();

    let [heurekaSettings, setHeurekaSettings] = useState({
        'hostNameAndCsvLinkList': projectIntegration?.hostNameAndCsvLinkList ?? '',
    });

    let createHeurekaIntegration = () => {
        new ProjectIntegrationsApi(authorityConfiguration)
            .heurekaIntegration({
                projectId: project.id,
                integrationId: projectIntegration?.id ?? null,
                heurekaIntegrationInput: heurekaSettings,
            })
            .then(heurekaIntegrationData => {
                navigate(
                    '/project/' + project.id + '/settings/integrations?integrationId=' + heurekaIntegrationData.id
                );
                resetCurrentUserProjects();
                toast.success(projectIntegration === null ? t('created') : t('saved'));
            })
            .catch(e => et(e).then(toast.error));
    };


    // noinspection JSUnresolvedReference
    return (
        <div className={'flex flex-col gap-2'}>

            <HostNameAndCsvLinkList
                project={project}
                projectIntegration={projectIntegration}
                value={heurekaSettings.hostNameAndCsvLinkList}
                onChange={(hostNameAndCsvLinkList) => {
                    setHeurekaSettings((heurekaSettings) => {
                        return {...heurekaSettings, hostNameAndCsvLinkList: hostNameAndCsvLinkList};
                    });
                }}
            />

            <div className={'min-h-4 max-h-4'}>{/* spacer */}</div>

            <div className={'flex justify-end'}>
                <Button
                    className={'button-primary'}
                    onClick={() => createHeurekaIntegration()}
                    title={t('project.integration-create')}
                >
                    {projectIntegration
                        ? t('project.integration-update')
                        : t('project.integration-create')}
                </Button>
            </div>
        </div>
    );
}
